// extracted by mini-css-extract-plugin
export default {"main__conteiner":"layout_main__conteiner__C6GP5"};